<template lang="pug">
  div(class="order")
    div catalog_id: 
      strong {{ order.catalog_id }}
    div(v-for="(item, index) in order.product_items" class="order--item")
      div
        div product_retailer_id
        span :
        strong {{ item.product_retailer_id }}
      div
        div quantity
        span :
        strong {{ item.quantity }}
      div
        div price
        span :
        strong {{ item.currency +' '+ item.item_price }}
</template>

<script>

export default {
  name: 'QiscusOrderComment',
  props: ['order'],
};
</script>


<style lang="stylus">
  @import '../assets/stylus/_variables.styl'
  .order > *
    margin: 1rem 0
  .order
    .order--item
      display: flex
      flex-direction: column
      div
        display: flex
        flex-wrap: wrap
        column-gap: 6px
      div
        &:first-child
          min-width: 124px
</style>


// WEBPACK FOOTER //
// src/components/CommentOrder.vue